import { render, staticRenderFns } from "./ProductCenter.vue?vue&type=template&id=9edbb25e&scoped=true&"
import script from "./ProductCenter.vue?vue&type=script&lang=js&"
export * from "./ProductCenter.vue?vue&type=script&lang=js&"
import style0 from "./ProductCenter.vue?vue&type=style&index=0&id=9edbb25e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edbb25e",
  null
  
)

export default component.exports